module.exports = require("inherits");